export const GET_REGION = "FUND@GET_REGION";
export const GET_REGION_INIT = "FUND@GET_REGION_INIT";
export const GET_REGION_SUCCESS = "FUND@GET_REGION_SUCCESS";
export const GET_REGION_FAILED = "FUND@GET_REGION_FAILED";

export const GET_STRATEGIES = "FUND@GET_STRATEGIES";
export const GET_STRATEGIES_INIT = "FUND@GET_STRATEGIES_INIT";
export const GET_STRATEGIES_SUCCESS = "FUND@GET_STRATEGIES_SUCCESS";
export const GET_STRATEGIES_FAILED = "FUND@GET_STRATEGIES_FAILED";

export const GET_SPECIALITIES = "FUND@GET_SPECIALITIES";
export const GET_SPECIALITIES_INIT = "FUND@GET_SPECIALITIES_INIT";
export const GET_SPECIALITIES_SUCCESS = "FUND@GET_SPECIALITIES_SUCCESS";
export const GET_SPECIALITIES_FAILED = "FUND@GET_SPECIALITIES_FAILED";

export const CREATE_FUND = "FUND@CREATE_FUND";
export const CREATE_FUND_INIT = "FUND@CREATE_FUND_INIT";
export const CREATE_FUND_SUCCESS = "FUND@CREATE_FUND_SUCCESS";
export const CREATE_FUND_FAILED = "FUND@CREATE_FUND_FAILED";
